import { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { store } from '@/store';
import { unreachable } from '@/utils/helpers';

import apiClient from './index';

const logOnDev = (message: string, log?: AxiosResponse | InternalAxiosRequestConfig | AxiosError) => {
  if (process.env.NEXT_PUBLIC_ENV === 'DEV') {
    console.log(message, log);
  }
};

apiClient.interceptors.request.use(async request => {
  // Store should be initialized before any requests
  if (!store) return unreachable();

  const { method, url } = request;
  logOnDev(`🚀 [${method?.toUpperCase()}] ${url} | Request`, request);

  return request;
});

apiClient.interceptors.response.use(
  response => {
    const { method, url } = response.config;
    const { status } = response;

    logOnDev(`✨ [${method?.toUpperCase()}] ${url} | Response ${status}`, response);

    return response;
  },
  async error => {
    const { message } = error;
    const { status, data } = error.response;
    const { method, url } = error.config;

    logOnDev(`🚨 [${method?.toUpperCase()}] ${url} | Error ${status} ${data?.message || ''} | ${message}`, error);

    return Promise.reject(error);
  },
);
